// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"124":"523d2345","223":"88abcafd","316":"6b24ef56","369":"3078c5de","523":"c73f9e99","849":"271b75ac","864":"15a7b154"}[chunkId] + ".css";
};